import { type JSX, memo } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  description?: string;
  title: JSX.Element | string;
  className?: string;
};

export const ModalHeader = memo(({ description, title, className }: Props) => (
  <div className={cnTwMerge("w-full", className)}>
    <div className="heading-4 pr-2">{title}</div>
    {isTruthy(description) ? (
      <div className="mt-2 text-sm font-light text-text/secondary">
        {description}
      </div>
    ) : null}
  </div>
));
